/* src/app/features/modalidade_garantia/modal-validacao-inadimplencia/modal-validacao-inadimplencia.component.scss */
.alert {
  margin-top: 1em !important;
}
/*# sourceMappingURL=modal-validacao-inadimplencia.component.css.map */
